import React from "react";
import styles from "./SimpleImageViewer.module.css";
import ElementAsset from "../../types/ElementAsset";

interface Props {
    image: ElementAsset;
    active: boolean;
    onClose: () => void;
}

export default function SimpleImageViewer({ image, active, onClose }: Props) {
    if (!active) return null;

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === "Escape") {
            onClose();
        }
    };

    React.useEffect(() => {
        if (active) {
            document.addEventListener("keydown", handleKeyDown);
            document.body.style.overflow = "hidden";
        }

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.body.style.overflow = "unset";
        };
    }, [active]);

    return (
        <div className={styles.backdrop} onClick={handleBackdropClick}>
            <button 
                className={styles.closeButton}
                onClick={onClose}
                aria-label="Close viewer"
            >
                <img
                    alt="Close"
                    width="24px"
                    height="24px"
                    src="/images/Close-black.svg"
                />
            </button>
            <div className={styles.container}>
                <div className={styles.header}>
                    <h3 className={styles.title}>{image.name}</h3>
                </div>
                <div className={styles.imageContainer}>
                    <img 
                        src={image.url} 
                        alt={image.name}
                        className={styles.image}
                        onError={(e) => {
                            (e.target as HTMLImageElement).src = '/images/Image-not-found.png';
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
